import { JSONEditor } from '@json-editor/json-editor'

const BaseEditor = JSONEditor.defaults.editors.number

class NumberEditor extends BaseEditor {
    constructor (options, defaults) {
        super(options, defaults)
        this.isBasic = options.jsoneditor.options.isBasic || false
        if (this.isBasic && this.options.displayInBasic !== true) {
            this.options.hidden = true
        }
    }
}

export default NumberEditor